const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, any>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as { default?: Record<string, any> };
    
    if (!messages[lang]) {
      messages[lang] = {};
    }
    
    // Utiliser les namespaces correctement
    if (module.default) {
      messages[lang][namespace] = module.default;
    }
  }
});

export default messages;
